class BundleMoreInfo extends HTMLElement {
  constructor() {
    super();

    this.initialise();
  }

  initialise() {
    const tabs = this.querySelectorAll('#tabTitle');
    const subheadings = this.querySelectorAll('.benefit-subheadings li');
    const infoBlocks = this.querySelectorAll('[data-info-block]');
    const images = this.querySelectorAll('.benefit-image img');

    images.forEach((image, index) => {
      if (index !== 0) {
        image.parentElement.classList.add('!tw-hidden');
      }
    });

    if (tabs.length > 0) {
      const firstTab = tabs[0];
      
      const highlightImage = firstTab.nextElementSibling;
      if (highlightImage && highlightImage.tagName === 'IMG') {
        highlightImage.classList.remove('tw-hidden');
      }
      const firstInfoName = firstTab.dataset.info;

      firstTab.classList.add('tw-font-semibold');
      const firstAssociatedInfoBlock = this.querySelector(`[data-info-block="${firstInfoName}"]`);
      if (firstAssociatedInfoBlock) {
        firstAssociatedInfoBlock.classList.remove('tw-hidden');
        firstAssociatedInfoBlock.classList.add('!tw-block');
      }

      const firstImage = this.querySelector(`.benefit-image[data-tab-image="${firstInfoName}"] img`);
      if (firstImage) {
        firstImage.parentElement.classList.remove('!tw-hidden');
      }

      infoBlocks.forEach((info) => {
        info.classList.remove('!tw-block');
        info.classList.add('tw-hidden');
      });

      firstTab.click();

      setTimeout(() => {
        const firstVisibleSubheading = this.querySelector(`.benefit-subheadings li[data-info="${firstInfoName}"]:not(.tw-hidden)`);
        if (firstVisibleSubheading) {
          firstVisibleSubheading.click();
        }
      }, 0);

      subheadings.forEach((subheading) => {
        if (subheading.dataset.info === firstInfoName) {
          subheading.classList.remove('tw-hidden');
        } else {
          subheading.classList.add('tw-hidden');
        }
      });

      const firstVisibleSubheading = this.querySelector(`.benefit-subheadings li[data-info="${firstInfoName}"]:not(.tw-hidden)`);
      if (firstVisibleSubheading) {
        firstVisibleSubheading.click();
      }
    }

    tabs.forEach((infoSelector) => {
      infoSelector.addEventListener('click', () => {
        const infoName = infoSelector.dataset.info;

        tabs.forEach((tab) => {
          tab.classList.remove('tw-font-semibold');
          const siblingImage = tab.nextElementSibling;
          if (siblingImage && siblingImage.tagName === 'IMG') {
            siblingImage.classList.add('tw-hidden');
          }
        });

        images.forEach((image) => {
          image.parentElement.classList.add('!tw-hidden');
        });

        infoBlocks.forEach((info) => {
          info.classList.remove('!tw-block');
          info.classList.add('tw-hidden');
        });

        infoSelector.classList.add('tw-font-semibold');

        const associatedInfoBlock = this.querySelector(`[data-info-block="${infoName}"]`);
        if (associatedInfoBlock) {
          associatedInfoBlock.classList.remove('tw-hidden');
          associatedInfoBlock.classList.add('!tw-block');
        }
        const tabHighlightImage = infoSelector.nextElementSibling;
        if (tabHighlightImage && tabHighlightImage.tagName === 'IMG') {
          tabHighlightImage.classList.remove('tw-hidden');
        }

        const associatedImage = this.querySelector(`.benefit-image[data-tab-image="${infoName}"] img`);
        if (associatedImage) {
          associatedImage.parentElement.classList.remove('!tw-hidden');
        }

        subheadings.forEach((subheading) => {
          subheading.classList.add('tw-hidden');
        });

        this.querySelectorAll(`.benefit-subheadings li[data-info="${infoName}"]`).forEach((subheading) => {
          subheading.classList.remove('tw-hidden');
        });

        const firstVisibleSubheading = this.querySelector(`.benefit-subheadings li[data-info="${infoName}"]:not(.tw-hidden)`);
        if (firstVisibleSubheading) {
          firstVisibleSubheading.click();
        }
      });
    });
    const scrollBelowHeader = (targetEl) => {
      // 1. Height of the sticky header (works for <store-header> or .store-header)
      const header = document.querySelector('store-header, .store-header');
      const headerHeight = header ? header.offsetHeight : 0;

      // 2. Height of *the* benefit image that is currently visible
      const benefitImage = document.querySelector('.benefit-image:not(.!tw-hidden)');
      // Hidden images have offsetHeight === 0, so this is safe
      const benefitHeight = benefitImage ? benefitImage.offsetHeight : 0;

      // 3. Absolute Y-position of the target block
      const targetY = targetEl.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -                // push it below the header
        benefitHeight + 1;            // and past the sticky image

      // 4. Smooth scroll
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    };
    subheadings.forEach((subheading) => {
      subheading.addEventListener('click', () => {
        const subheadingInfoContent = subheading.dataset.infoContent;
        const infoBlock = this.querySelector(`div[data-info-content="${subheadingInfoContent}"]`);

        subheadings.forEach((sh) => {
          sh.classList.remove('tw-font-semibold');
          const image = sh.querySelector('img[data-highlight]');
          if (image) {
            image.classList.add('tw-hidden');
          }
          sh.querySelector('[data-minus]').classList.add('tw-hidden');
          sh.querySelector('[data-plus]').classList.remove('tw-hidden');
        });

        const sameInfoSubheadings = Array.from(subheadings).filter((sh) => sh.dataset.infoContent === subheading.dataset.infoContent);

        sameInfoSubheadings.forEach((subheading) => {
          subheading.classList.add('tw-font-semibold');
          const associatedImage = subheading.querySelector('img[data-highlight]');
          if (associatedImage) {
            associatedImage.classList.remove('tw-hidden');
          }
          subheading.querySelector('[data-minus]').classList.remove('tw-hidden');
          subheading.querySelector('[data-plus]').classList.add('tw-hidden');
        });

        if (infoBlock) {
          infoBlocks.forEach((info) => {
            info.classList.remove('!tw-block');
            info.classList.add('tw-hidden');
          });

          infoBlock.classList.remove('tw-hidden');
          infoBlock.classList.add('!tw-block');
        }

        // RS. Scroll the component sit below the header
        // Scroll triggered under < 1024px
        if (window.innerWidth < 1024) {
          const header = document.querySelector('store-header');
          const headerHeight = header ? header.offsetHeight : 0;

          const subHeadingsEl = subheading.closest('.benefit-subheadings');
          if (!subHeadingsEl) return;

          const offset = subHeadingsEl.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight + 2;

          window.scrollTo({ top: Math.max(offset, 0), behavior: 'smooth' });
        }
      });
    });
  }
}

customElements.define('bundle-more-info', BundleMoreInfo);